import sagas from './sagas';
import sagaManager from '../../../../redux/sagaManager';

sagaManager.addSagaToRoot(sagas);

export { default } from './_CpsrLoadTemplateModalContainer';
